import React from "react"
import PropTypes from "prop-types"

import TrackingScript from "./tracking/TrackingScript"
import TrackingCrmScript from "./tracking/TrackingCrmScript"
import Footer from "./../components/shared/footer"
import NavBar from "./../components/shared/navBar"
import "./i18n"

import LoadingProvider from "./../components/context/LoadingContext"
import { PostsContextProvider } from "./../components/context/PostsContext"

import "../styles/animate.min.css"
import "../styles/index.css"
import "../styles/styles.css"
import "../styles/App.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const Layout = ({ children }) => {
  return (
    <LoadingProvider>
      <PostsContextProvider>
        <NavBar />
        {/*  <Header siteTitle={data.site.siteMetadata.title} siteDesc={data.site.siteMetadata.description} /> */}

        <main className="App">{children}</main>

        {/*<Sidebar>
        <RecentPosts />
      </Sidebar> */}
        <Footer />
        <TrackingScript />
        <TrackingCrmScript />
      </PostsContextProvider>
    </LoadingProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
